<section class="grid-container">
    <tabs (tabClicked)="onTabClicked($event)">
        <tab title="Issued">
            <ag-grid-angular class="data-grid " [gridOptions]="issuedGridOptions" [rowData]="issuedChiefsOrderInstanceData" [attr.aria-label]="widgetTitle + ' - Issued'"></ag-grid-angular>
        </tab>
        <tab title="Appealed">
            <ag-grid-angular class="data-grid " [gridOptions]="appealedGridOptions" [rowData]="appealedChiefsOrderInstanceData" [attr.aria-label]="widgetTitle + ' - Appealed'"></ag-grid-angular>
        </tab>
        <tab title="Vacated">
            <ag-grid-angular class="data-grid " [gridOptions]="vacatedGridOptions" [rowData]="vacatedChiefsOrderInstanceData" [attr.aria-label]="widgetTitle + ' - Vacated'"></ag-grid-angular>
        </tab>
        <tab title="Revoked">
            <ag-grid-angular class="data-grid " [gridOptions]="revokedGridOptions" [rowData]="revokedChiefsOrderInstanceData" [attr.aria-label]="widgetTitle + ' - Revoked'"></ag-grid-angular>
        </tab>
        <tab title="Suspended">
            <ag-grid-angular class="data-grid " [gridOptions]="suspendedGridOptions" [rowData]="suspendedChiefsOrderInstanceData" [attr.aria-label]="widgetTitle + ' - Suspended'"></ag-grid-angular>
        </tab>
        <tab title="Modified">
            <ag-grid-angular class="data-grid " [gridOptions]="modifiedGridOptions" [rowData]="modifiedChiefsOrderInstanceData" [attr.aria-label]="widgetTitle + ' - Modified'"></ag-grid-angular>
        </tab>
        <tab title="Terminated">
            <ag-grid-angular class="data-grid " [gridOptions]="terminatedGridOptions" [rowData]="terminatedChiefsOrderInstanceData" [attr.aria-label]="widgetTitle + ' - Terminated'"></ag-grid-angular>
        </tab>
    </tabs>
</section>